import { Injectable } from '@angular/core';

import { TrimDescription } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class TrimDescriptionService extends TmsWebBaseEditService<TrimDescription, TrimDescription> {
  constructor() {
    super('TrimDescription', $localize`Trim Description`);
  }
}
